import styled from "styled-components";

const InputFieldWrapper = styled.div`
  display: flex;
  width: 40%;
  margin-top: 24px;
  border: 1px solid #436ab2;
  border-radius: 6px;
  padding: 5px;
  justify-content: left;
  cursor: pointer;
  height: 50px;
  margin-right: 20px;
  /* & > input{
        display: none;
    }   */
`;

const InputField = styled.input`
  border: 0;
  outline: none;
  height: auto;
  width: 100%;
  font-size: medium;
  padding-left: 18px;
`;

const HomeWrapper = styled.div`
  transition: margin-left 0.2s ease-in;
  padding: 0px 0px 20px 80px;
  padding-bottom: 20px;
  box-sizing: border-box;
  background: #fff;
  margin-left: 200px;
  max-width: 800px;
  /* box-shadow: rgb(0 0 0 / 15%) 0px 1px 4px 0px; */
`;

export { InputFieldWrapper, InputField, HomeWrapper };
